import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { mapUserCpdCategorys } from "../../../../services";
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_SNAPSHOT_REPORT: (userId, snapshotId) => ({ userId, snapshotId }),
    API: {
      GET_SNAPSHOT_REPORT: apiResourceActionCreator('report')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.get(`${API_ENDPOINT}/reports/users/${payload.userId}/snapshots/${payload.snapshotId}`, authToken, action.admin.api.getSnapshotReport);

function* getSnapshotReport(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'getSnapshotReport',
  action: action,
  sagas: getSnapshotReport,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingReport: true
    }),
    success: (state, action) => {
      const {
        user: {
          details,
          ...userProps
        },
        cpdCategorys,
        userCpdCategorys,
        fromDate,
        toDate,
        userIndustry
      } = action.payload.report
      return {
        ...state,
        isFetchingReport: false,
        report: {
          ...action.payload.report,
          filter: {
            fromDate,
            toDate
          },
          user: {
            ...userProps,
            ...details
          },
          cpdCategorys,
          userIndustryType: userIndustry.industryType,
          userCpdCategorys: mapUserCpdCategorys(cpdCategorys)(userCpdCategorys)
        }
      };
    },
    failed: (state, action) => ({
      ...state,
      isFetchingReport: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getSnapshotReport.js